import { Component, OnInit, ViewChild } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';//CDPJ
import { isNullOrUndefined } from 'util';

import { Prodmaecentra } from "../prodinterfaces/prodmaecentra";
import { ProdmaecentrbajoService } from "../prodservicios/prodmaecentrbajo.service";
@Component({
  selector: 'app-prodmaecentrbajo',
  templateUrl: './prodmaecentrbajo.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class ProdmaecentrbajoComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  btnNuevo: boolean;
  btnGuardar: boolean;
  btnBorrar: boolean;
  btnRegresar: boolean;

  permisoMaecentra: SegMaePermiso;
  largo: string;
  arregloCons: any[];
  centrabSeleccionado: Prodmaecentra;

  public frameworkComponents;
  rowStyle;
  desCodigo: boolean;
  defaultColDefCentrab;
  rowSelection = 'multiple';

  indicador: any;

  columnDefsCentrab = [
    {
      headerName: 'Código', field: 'CENTRA_CODIGO', cellEditor: 'cellPrueba', width: 120, editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10
        }
      }
    },
    {
      headerName: 'Descripción', field: 'CENTRA_DESCRIPCION', cellEditor: 'cellPrueba', width: 250,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 100
        }
      }
    },

  ];

  constructor(
    public prodmaecentrbajoService: ProdmaecentrbajoService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private busqService: InvbusquedaService, private permisosService: PermisosService,
    private auditoriagral: AuditoriagralService, private init: NuevoComponentService,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefCentrab = {
      editable: true,
      width: 100,
      objeto: 'maecentrab'
    };
  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.largo = '258';
    this.prodmaecentrbajoService.prodmaecentrab = []
    await this.getPermisos()
    await this.cargarcentrab()
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoMaecentra = data[0];
        } else {
          this.permisoMaecentra = null;
        }
      } else {
        this.permisoMaecentra = null;
      }
    } catch (e) {
      this.permisoMaecentra = null;
      this.messageService.add({
        key: 'centrab',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  async cargarcentrab() {
    try {
      this.prodmaecentrbajoService.prodmaecentrab = []
      const data = await this.prodmaecentrbajoService.getcentrab();
      if (data !== null && Object.keys(data).length > 0) {
        for (const iterator of data) {
          iterator.NUEVO = false
        }
        this.prodmaecentrbajoService.prodmaecentrab = data
      }

    } catch (error) {
      this.messageService.add({
        key: 'centrab',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar los centros de trabajo'
      });
    }
  }
  manejarSenales(valor) {
    if (valor === 'Nuevo') {
      if (this.permisoMaecentra.PERINSERCION === 1) {
        this.btnNuevo = true;
        this.btnGuardar = false;
        this.btnBorrar = false;
        this.btnRegresar = false;
        this.aggrid.isEditable(true);
        this.centrabSeleccionado = {
          CENTRA_CODIGO: '',
          CENTRA_DESCRIPCION: '',
          COM_CODIGO: '01',
          NUEVO: true
        };
        this.prodmaecentrbajoService.prodmaecentrab.push(this.centrabSeleccionado);
        this.aggrid.refreshaggrid(this.prodmaecentrbajoService.prodmaecentrab, this.defaultColDefCentrab.objeto);
      } else if (this.permisoMaecentra.PERINSERCION === 0) {
        this.messageService.add({
          key: 'centrab',
          severity: 'error',
          summary: 'Inserción',
          detail: 'El usuario no tiene permisos de inserción, acción denegada'
        });
      }
    }
    if (valor === 'Guardar') {
      // if (this.permisoVenServicios.PERACTUALIZACION === 1) {

      this.btnGuardar = true;

      if (this.centrabSeleccionado.CENTRA_CODIGO === '' || isNullOrUndefined(this.centrabSeleccionado.CENTRA_CODIGO)) {
        this.messageService.add({
          key: 'centrab',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un centro de trabajo para poderlo guardar'
        });
        this.btnGuardar = false;
        return
      }
      try {
        this.prodmaecentrbajoService.frcentrab(this.centrabSeleccionado.CENTRA_CODIGO).subscribe(async existe => {
          if (existe !== null) {

            await this.prodmaecentrbajoService.actualizarcentrab(this.centrabSeleccionado);
            await this.auditoriagral.registrarAuditoria('PROD_MAECENTRA', String(this.centrabSeleccionado.CENTRA_CODIGO) + '/Descripcion:' +
              this.centrabSeleccionado.CENTRA_DESCRIPCION, 'A', '',
              '01', '', '', '', '').toPromise();

            this.btnNuevo = false;
            this.btnGuardar = true;
            this.btnBorrar = false;
            this.btnRegresar = true;
            this.messageService.add({
              key: 'centrab',
              severity: 'success',
              summary: 'Actualización exitosa',
              detail: 'Se actualizó el centro de trabajo correctamente'
            });
            await this.cargarcentrab();

          } else if (existe === null) {
            await this.prodmaecentrbajoService.insertarcentrab(this.centrabSeleccionado);
            await this.auditoriagral.registrarAuditoria('PROD_MAECENTRA', String(this.centrabSeleccionado.CENTRA_CODIGO) + '/Descripcion:' +
              this.centrabSeleccionado.CENTRA_DESCRIPCION, 'I', '',
              '01', '', '', '', '').toPromise();

            this.btnNuevo = false;
            this.btnGuardar = true;
            this.btnBorrar = false;
            this.btnRegresar = true;
            this.messageService.add({
              key: 'centrab',
              severity: 'success',
              summary: 'Inserción exitosa',
              detail: 'Se insertó el centro de trabajo correctamente'
            });
            await this.cargarcentrab();
          }
        });
      } catch (error) {
        this.messageService.add({
          key: 'centrab',
          severity: 'error',
          summary: 'Información',
          detail: 'Ocurrió un error al guardar los datos'
        });
        console.log(error)
      }

    }
    if (valor === 'Borrar') {
      if (this.permisoMaecentra.PERELIMACION === 1) {

        if (this.centrabSeleccionado === undefined) {
          this.messageService.add({
            key: 'centrab',
            severity: 'error',
            summary: 'Eliminación',
            detail: 'Selección Incorrecta, no se ha seleccionado un centro de trabajo'
          });
        } else {
          this.confirmarServicio();
        }
      } else if (this.permisoMaecentra.PERELIMACION === 0) {
        this.messageService.add({
          key: 'centrab',
          severity: 'error',
          summary: 'Eliminación',
          detail: 'El usuario no tiene permisos de elimminación, acción denegada'
        });
      }
    }
    if (valor === 'Cancelar') {
      this.cancelar()
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  cancelar() {
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.cargarcentrab();
  }
  confirmarServicio() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea elminiar el centro de trabajo',
      header: 'Eliminar Centro Trabajo',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmarCentrab',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.eliminarCentra();
      },
      reject: () => {
      }
    });
  }
  async eliminarCentra() {
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    try {
      const data = await this.prodmaecentrbajoService.consulcentra(this.centrabSeleccionado.CENTRA_CODIGO)
      if (data !== null && Object.keys(data).length > 0) {
        for (const iterator of data) {
          if (iterator.NUMERO > 0) {
            this.messageService.add({
              key: 'centrab',
              severity: 'error',
              summary: 'Eliminación',
              detail: 'No se puede eliminar el centro de trabajo, porque ya ha sido utilizado en un costo indirecto por fase '
            });
            return
          }
        }
      }
      await this.prodmaecentrbajoService.eliminarcentrab(this.centrabSeleccionado.CENTRA_CODIGO)
      await this.auditoriagral.registrarAuditoria('PROD_MAECENTRA', String(this.centrabSeleccionado.CENTRA_CODIGO) + '/Descripcion:' +
        this.centrabSeleccionado.CENTRA_DESCRIPCION, 'E', '',
        '01', '', '', '', '').toPromise();
      this.messageService.add({
        key: 'centrab',
        severity: 'success',
        summary: 'Eliminación exitosa',
        detail: 'Se eliminó el centro de trabajo correctamente'
      });
      await this.cancelar();
    } catch (error) {
      this.messageService.add({
        key: 'centrab',
        severity: 'error',
        summary: 'Eliminación',
        detail: 'Ocurrió un error al elimnar el centro de trabajo'
      });
      console.log(error)
    }

  }
  selectedCentrab(params) {
    if (params.object !== null) {
      this.centrabSeleccionado = params.object;
    }
  }
  cambio() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = false;
    this.btnRegresar = false;
  }
}
